module.exports = __webpack_public_path__ + "img/img_communication_28.53057854.jpg";